import React, { useState, useRef, cloneElement } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Tooltip from '../../../libraries/utils/components/tooltip';
import Droplist from '../../../libraries/utils/components/droplist';
import ButtonSmall from '..//moderation-v2/sharable/components/ButtonSmall';
const displayName = 'DropDownLink';

function DropDownLink(props) {
  const {
    items,
    text,
    caret,
    customContent,
    tooltipClassName,
    tooltipRenderOutsideContainer,
    tooltipAlignPositionType
  } = props;
  const menuLabelRef = useRef(null);
  const menuItemRef = useRef(null);

  const handleMoreClick = () => {
    menuItemRef.current.toggle();
    if (props.onClick) {
      props.onClick();
    }
  };

  const hideItemsHandler = () => {
    if (!props?.clickApply) {
      menuItemRef.current.hide();
    }
  };

  const onClickApply = () => {
    props?.clickApply();
    menuItemRef.current.hide();
  };

  const onClickClear = () => {
    props?.clickClear();
    menuItemRef.current.hide();
  }

  return (
    <span
      className={cx('menu-label', props.className)}
      ref={menuLabelRef}
      onClick={handleMoreClick}
    >
      {props.children}
      {text}
      <Tooltip
        className={cx('dropdown tooltip-general', tooltipClassName)}
        hasScreenBoundries
        caret={caret}
        ref={menuItemRef}
        renderOutsideContainer={tooltipRenderOutsideContainer}
        alignPositionType={tooltipAlignPositionType}
        alignElement={() => menuLabelRef.current}
      >
        {customContent ? (
          cloneElement(customContent, { onHide: hideItemsHandler })
        ) : (
          <>
            <Droplist items={items} hideItems={hideItemsHandler} />
            {props?.clickApply && (
              <div className={'buttonsContainer'}>
                <ButtonSmall className={'clearButton'} onClick={onClickClear}>
                  Clear Filters
                </ButtonSmall>
                <ButtonSmall className={'applyButton'} onClick={onClickApply}>
                  Apply
                </ButtonSmall>
              </div>
            )}
          </>
        )}
      </Tooltip>
    </span>
  );
}

DropDownLink.propTypes = {
  children: PropTypes.element,
  items: PropTypes.array,
  text: PropTypes.string,
  className: PropTypes.string,
  caret: PropTypes.bool,
  clickClear: PropTypes.func,
  clickApply: PropTypes.func,
  customContent: PropTypes.node,
  tooltipClassName: PropTypes.string,
  tooltipRenderOutsideContainer: PropTypes.bool,
  tooltipAlignPositionType: PropTypes.oneOf(['absolute', 'relative'])
};

DropDownLink.displayName = displayName;

export default DropDownLink;
